import httpClient from './http-client';

export default class ProductService {
    private baseApiEndpoint = '/api/prds';
    private idToken: string | undefined = '';

    constructor(idToken?: string | undefined) {
        this.idToken = idToken;
        this.baseApiEndpoint = import.meta.env.VITE_BYPASS_PROXY === 'true'
                                ? '' : this.baseApiEndpoint;
    }

    async getBrands(): Promise<any> {
        let response;
        try {
            response = await httpClient.get(
                `${this.baseApiEndpoint}/products/brands/`,
                {
                    headers: {
                        // 'X-Authorization': `Bearer ${this.accessToken}`,
                    },
                }
            );
            return response?.data || null;
        } catch (error) {
            console.error('Error fetching details:', error);
             throw error;
        }
    }

    async getBaseModels(): Promise<any> {
        let response;
        try {
            response = await httpClient.get(
                `${this.baseApiEndpoint}/products/base-models?spare_part=n&pagination=n`,
                {
                    headers: {
                        // 'X-Authorization': `Bearer ${this.accessToken}`,
                    },
                }
            );
            return response?.data || null;
        }
        catch (error) {
            console.error('Error fetching details:', error);
             throw error;
        }
    }


}
